export default "<div class=\"vh-100\">\r\n  \r\n</div>";